<template>
  <pagefra>
    <div
      class="account container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            :inline="true"
            v-model="form"
            size="medium"
            class="toolbar-form"
          >
            <el-form-item :label="$l('用户名')">
              <el-input
                v-model="form.username"
                maxlength="30"
                :placeholder="$l('用户名')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('手机号')">
              <el-input
                v-model="form.telNum"
                maxlength="11"
                :placeholder="$l('手机号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('角色名称')">
              <el-select v-model="form.roleId" :placeholder="$l('角色名称')">
                <el-option :label="$l('全部')" value="-1"></el-option>
                <el-option
                  v-for="item in roleList1"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('用户类型')">
              <el-select v-model="form.userType" :placeholder="$l('用户类型')">
                <el-option :label="$l('全部')" value=""></el-option>
                <el-option :label="$l('日立')" value="1"></el-option>
                <el-option :label="$l('物业')" value="2"></el-option>
                <el-option :label="$l('家用梯')" value="3"></el-option>
                <el-option :label="$l('电梯服务商')" value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('签单分公司')">
              <el-input
                v-model="form.signingBranch"
                maxlength="100"
                :placeholder="$l('签单分公司')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('客户名称')">
              <el-input
                v-model="form.customer"
                maxlength="100"
                :placeholder="$l('客户名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('使用类型')">
              <el-select v-model="form.useType" :placeholder="$l('使用类型')">
                <el-option :label="$l('全部')" value=""></el-option>
                <el-option :label="$l('按需保养')" value="按需保养"></el-option>
                <el-option :label="$l('保养赠送')" value="保养赠送"></el-option>
                <el-option :label="$l('保修赠送')" value="保修赠送"></el-option>
                <el-option :label="$l('改造赠送')" value="改造赠送"></el-option>
                <el-option :label="$l('技援赠送')" value="技援赠送"></el-option>
                <el-option
                  :label="$l('金牌服务中心赠送')"
                  value="金牌服务中心赠送"
                ></el-option>
                <el-option
                  :label="$l('营分司推广使用')"
                  value="营分司推广使用"
                ></el-option>
                <el-option
                  :label="$l('数字付费合同')"
                  value="数字付费合同"
                ></el-option>
                <el-option :label="$l('推广体验')" value="推广体验"></el-option>
                <el-option
                  :label="$l('维保大客户协议赠送')"
                  value="维保大客户协议赠送"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('是否禁用')">
              <el-select v-model="form.disabled" :placeholder="$l('是否禁用')">
                <el-option :label="$l('全部')" value=""></el-option>
                <el-option :label="$l('启用')" value="0"></el-option>
                <el-option :label="$l('禁用')" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('员工工号')">
              <el-input
                v-model="form.employeeId"
                maxlength="50"
                :placeholder="$l('员工工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('公司名称')">
              <el-input
                v-model="form.companyName"
                maxlength="50"
                :placeholder="$l('公司名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('创建人')">
              <el-input
                v-model="form.creator"
                maxlength="30"
                :placeholder="$l('创建人')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('到期时间')">
              <el-date-picker
                v-model="expireTimeValues"
                type="daterange"
                :range-separator="$l('至')"
                :start-placeholder="$l('到期开始时间')"
                :end-placeholder="$l('到期结束时间')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              round
              type="primary"
              icon="el-icon-plus"
              @click="showAdd()"
              v-if="hasPermission('新增')"
              >{{ $l("新增") }}
            </el-button>
            <el-button
              round
              icon="el-icon-delete"
              @click="deleteUser"
              v-if="hasPermission('删除')"
              >{{ $l("删除") }}
            </el-button>
            <el-button
              round
              icon="el-icon-upload2"
              @click="openImportUser(0)"
              v-if="hasPermission('导入用户')"
            >
              {{ $l("导入用户") }}
            </el-button>
            <el-button
              round
              icon="el-icon-upload2"
              @click="openImportElevator(0)"
              v-if="hasPermission('导入电梯权限')"
            >
              {{ $l("导入电梯权限") }}
            </el-button>
            <el-button
              round
              icon="el-icon-upload2"
              @click="clearElevatorPermission"
              v-if="hasPermission('清空电梯权限')"
            >
              {{ $l("清空电梯权限") }}
            </el-button>
            <el-button
              round
              icon="el-icon-download"
              @click="exportElevator"
              v-if="hasPermission('导出电梯权限')"
              >{{ $l("导出电梯权限") }}
            </el-button>
            <el-button
              round
              icon="el-icon-download"
              @click="exportUser"
              v-if="hasPermission('导出')"
            >
              {{ $l("导出") }}
            </el-button>
            <el-button
              round
              icon="el-icon-refresh"
              @click="refreshUserElevatorCount"
              v-if="hasPermission('刷新账号统计')"
              >{{ $l("刷新账号统计") }}
            </el-button>
            <el-button
              round
              icon="el-icon-position"
              @click="sendSMS"
              v-if="hasPermission('发送短信')"
              >{{ $l("发送短信") }}
            </el-button>
            <el-button
              round
              icon="el-icon-plus"
              @click="showAddSubUser"
              v-if="
                hasPermission('新增副账号') &&
                $store.state.user.accountType == 1 &&
                $store.state.user.roleType != 1
              "
              >{{ $l("新增副账号") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="singleTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            v-loading.lock="loading"
            :element-loading-text="$l('加载中')"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              property="username"
              :label="$l('用户名')"
              width="120"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <!-- <el-table-column
              property="areaName"
              :label="$l('所属区域')"
              width="150"
              header-align="center"
              align="center"
            >
            </el-table-column> -->
            <el-table-column
              property="roleName"
              :label="$l('角色名称')"
              min-width="120"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="userType"
              :label="$l('用户类型')"
              width="120"
              header-align="center"
              align="center"
              :formatter="userTypeFormatter"
            >
            </el-table-column>
            <el-table-column
              property="disabled"
              :label="$l('是否禁用')"
              width="120"
              header-align="center"
              align="center"
              :formatter="disabledFormatter"
            >
            </el-table-column>
            <el-table-column
              property="syncStatus"
              :label="$l('权限同步')"
              width="120"
              header-align="center"
              align="center"
              :formatter="syncStatusFormatter"
            >
            </el-table-column>
            <el-table-column
              property="expireDate"
              :label="$l('到期时间')"
              width="120"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="telNum"
              :label="$l('手机号')"
              width="180"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="creator"
              :label="$l('创建人')"
              width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="createDate"
              :label="$l('创建时间')"
              min-width="180"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="lastAccessDate"
              :label="$l('上次访问时间')"
              width="180"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="updater"
              :label="$l('最后修改人')"
              width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="updateDate"
              :label="$l('最后修改时间')"
              width="180"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="remark"
              :label="$l('备注')"
              min-width="300"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="employeeId"
              :label="$l('员工工号')"
              width="120"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="employeeName"
              :label="$l('员工姓名')"
              width="120"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="companyName"
              :label="$l('公司名称')"
              width="200"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="jobStatus"
              :label="$l('在职状态')"
              width="80"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.jobStatus == 'Y'" style="color: green"
                  >{{ $l("在职") }}
                </span>
                <span v-else-if="scope.row.jobStatus == 'N'" style="color: red"
                  >{{ $l("离职") }}
                </span>
                <span v-else></span>
              </template>
            </el-table-column>
            <el-table-column
              property="signingBranch"
              :label="$l('签单分公司')"
              width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="customer"
              :label="$l('客户名称')"
              width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="useType"
              :label="$l('使用类型')"
              width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="elevatorCount"
              :label="$l('电梯台量')"
              width="120"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              :label="$l('编辑')"
              min-width="120"
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('编辑')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showEdit(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                >
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('数据权限')"
              min-width="80"
              header-align="center"
              align="center"
              fixed="right"
              v-if="
                hasPermission('数据权限') && $store.state.user.userType == 1
              "
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showDataPermission(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                  v-if="
                    scope.row.userId != $store.state.user.userId &&
                    scope.row.userType == 1
                  "
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('单梯设置')"
              min-width="120"
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('单梯设置')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showBindElevator(scope.row.userId, 1)"
                  type="primary"
                  clear
                  icon="el-icon-setting"
                >
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('多梯设置')"
              min-width="120"
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('多梯设置')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showBindElevator(scope.row.userId, 2)"
                  type="primary"
                  clear
                  icon="el-icon-setting"
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        ref="editDialog"
        :title="$l(editDialogTitle)"
        :visible.sync="editDialogVisible"
      >
        <el-form
          ref="editForm"
          :model="editForm"
          label-width="140px"
          size="medium"
          class="dialog-form"
          :rules="rules"
        >
          <el-form-item :label="$l('用户名')" prop="username">
            <el-input v-model="editForm.username" :disabled="!isAdd"></el-input>
          </el-form-item>
          <el-form-item :label="$l('密码')" prop="password">
            <el-input type="password" v-model="editForm.password"></el-input>
          </el-form-item>
          <el-form-item :label="$l('重复密码')" prop="repassword">
            <el-input type="password" v-model="editForm.repassword"></el-input>
          </el-form-item>
          <el-form-item :label="$l('手机号')" prop="telNum">
            <el-input v-model="editForm.telNum"></el-input>
          </el-form-item>
          <el-form-item :label="$l('角色名称')">
            <el-select
              v-model="editForm.roleId"
              :disabled="!isAdd && $store.state.user.userId == editForm.userId"
            >
              <el-option
                v-for="item in roleList2"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$l('用户类型')">
            <el-select
              v-model="editForm.userType"
              :disabled="!isAdd || (isAdd && $store.state.user.userType > 1)"
            >
              <el-option :label="$l('日立')" value="1"> </el-option>
              <el-option :label="$l('物业')" value="2"> </el-option>
              <el-option :label="$l('家用梯')" value="3"> </el-option>
              <el-option :label="$l('电梯服务商')" value="4"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$l('到期时间')">
            <el-date-picker
              v-model="editForm.expireDateObj"
              type="datetime"
              :picker-options="expirePickerOptions"
              :placeholder="$l('选择日期时间')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$l('是否禁用')">
            <el-switch v-model="editForm.disabled"></el-switch>
          </el-form-item>
          <el-form-item :label="$l('账号归属')">
            <el-checkbox
              v-if="
                editForm.accountType != 2 &&
                editForm.userId != $store.state.user.userId &&
                $store.state.user.roleType == 1 &&
                editForm.oldAccountType != 2
              "
              v-model="editForm.accountType"
              :true-label="1"
              :false-label="0"
              >{{ $l("主账号") }}</el-checkbox
            >
            <span
              v-if="
                editForm.accountType == 1 &&
                ($store.state.user.userId == editForm.userId ||
                  $store.state.user.roleType != 1 ||
                  editForm.oldAccountType == 2)
              "
              style="color: #606266"
              >{{ $l("主账号") }}</span
            >
            <span v-if="editForm.accountType == 2" style="color: #606266">{{
              $l("副账号")
            }}</span>
          </el-form-item>
          <el-form-item :label="$l('新增短信接收人数')">
            <el-input-number
              v-model="editForm.smsReceiverNum"
              :min="0"
              :label="$l('新增短信接收人数')"
              :controls="false"
            ></el-input-number>
          </el-form-item>
          <el-form-item :label="$l('微信用户绑定人数')">
            <el-input-number
              v-model="editForm.wxCount"
              :min="0"
              :label="$l('微信用户绑定人数')"
              :controls="false"
            ></el-input-number>
          </el-form-item>
          <el-form-item :label="$l('全天监控')">
            <el-switch v-model="editForm.monitor"></el-switch>
          </el-form-item>
          <el-form-item :label="$l('签单分公司')" prop="signingBranch">
            <el-input v-model="editForm.signingBranch"></el-input>
          </el-form-item>
          <el-form-item :label="$l('客户名称')" prop="customer">
            <el-input v-model="editForm.customer"></el-input>
          </el-form-item>
          <el-form-item :label="$l('使用类型')">
            <el-select v-model="editForm.useType">
              <el-option :label="$l('按需保养')" value="按需保养"></el-option>
              <el-option :label="$l('保养赠送')" value="保养赠送"></el-option>
              <el-option :label="$l('保修赠送')" value="保修赠送"></el-option>
              <el-option :label="$l('改造赠送')" value="改造赠送"></el-option>
              <el-option :label="$l('技援赠送')" value="技援赠送"></el-option>
              <el-option
                :label="$l('金牌服务中心赠送')"
                value="金牌服务中心赠送"
              ></el-option>
              <el-option
                :label="$l('营分司推广使用')"
                value="营分司推广使用"
              ></el-option>
              <el-option
                :label="$l('数字付费合同')"
                value="数字付费合同"
              ></el-option>
              <el-option :label="$l('推广体验')" value="推广体验"></el-option>
              <el-option
                :label="$l('维保大客户协议赠送')"
                value="维保大客户协议赠送"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$l('日立员工工号')" prop="telNum">
            <el-input v-model="editForm.employeeId"></el-input>
          </el-form-item>
          <el-form-item :label="$l('备注')" prop="remark">
            <el-input type="textarea" v-model="editForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-row type="flex">
            <!-- <el-button type="primary" plain round icon="el-icon-upload2">导入设置</el-button> -->
            <el-col>
              <el-button round @click="editDialogVisible = false"
                >{{ $l("取消") }}
              </el-button>
              <el-button round type="primary" @click="submit"
                >{{ $l("确定") }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
      <el-dialog
        :title="$l('数据范围')"
        :visible.sync="treeDialogVisible"
        width="30%"
      >
        <el-tree
          ref="tree"
          :data="dataTree"
          show-checkbox
          node-key="id"
          :props="treeProps"
          lazy
          :default-expanded-keys="expandedKeys1"
          @node-expand="nodeExpand"
          v-loading.lock="treeLoading"
        ></el-tree>
        <span slot="footer" class="dialog-footer">
          <el-button @click="treeDialogVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="setUserPermission"
            >{{ $l("确 定") }}
          </el-button>
        </span>
      </el-dialog>
      <el-dialog
        :title="$l('导入用户')"
        :visible.sync="importUserDialogVisible"
        width="30%"
      >
        <el-upload
          ref="upload"
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :limit="2"
          :file-list="fileList"
          :on-change="onFileChange"
          :on-remove="onFileRemove"
          list-type="text"
          :auto-upload="false"
        >
          <el-button size="small" round type="primary"
            >{{ $l("点击上传") }}
          </el-button>
          <div slot="tip" class="el-upload__tip">
            {{ $l("只能上传xlsx文件") }}

            <a
              href="#"
              style="text-decoration: none"
              @click="downloadTemplate('用户模板.xlsx')"
              >{{ $l("模板文件") }}
            </a>
          </div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="importUserDialogVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="importUser"
            >{{ $l("确 定") }}
          </el-button>
        </span>
      </el-dialog>
      <el-dialog
        :title="$l('导入电梯权限')"
        :visible.sync="importElevatorDialogVisible"
        width="30%"
      >
        <el-upload
          ref="upload"
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :limit="2"
          :file-list="fileList"
          :on-change="onFileChange"
          :on-remove="onFileRemove"
          list-type="text"
          :auto-upload="false"
        >
          <el-button size="small" round type="primary"
            >{{ $l("点击上传") }}
          </el-button>
          <div slot="tip" class="el-upload__tip">
            {{ $l("只能上传xlsx文件") }}
            <a
              href="#"
              @click="downloadTemplate('电梯工号模板.xlsx')"
              style="text-decoration: none"
              >{{ $l("模板文件") }}
            </a>
          </div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="importElevatorDialogVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="importElevator"
            >{{ $l("确 定") }}
          </el-button>
        </span>
      </el-dialog>
      <el-dialog
        :title="$l('设置数据权限')"
        :visible.sync="setDataPermissionDialogVisible"
        width="600px"
      >
        <div class="inputfra inputfra--inset">
          <el-row type="flex" :gutter="15">
            <!-- <el-col :span="9">
              <panel padding height="360px" class="tagListPanel">
                <p>已选：</p>
                <el-tag
                  v-for="(item, i) in selectedDataPermissionList"
                  round
                  block
                  type="default "
                  closable
                  @close="closeSelectedTag(item.id, i)"
                  >{{ item.names }}</el-tag
                >
              </panel>
            </el-col> -->
            <el-col :span="24" class="container">
              <panel class="filter" height="64px">
                <el-input
                  v-model="filterText"
                  :placeholder="$l('输入关键字进行过滤')"
                ></el-input>
                <el-checkbox @change="onCheckChange" v-model="isGrtFlg"
                  >{{ $l("在保") }}
                </el-checkbox>
              </panel>
              <panel
                padding
                height="280px"
                style="margin-bottom: 0"
                v-loading.lock="dataPermissionLoading"
                :element-loading-text="$l('加载中')"
              >
                <el-tree
                  ref="dataPermissionTree"
                  :data="dataPermissionList"
                  :load="loadDataPermissionNode"
                  node-key="ids"
                  lazy
                  show-checkbox
                  check-strictly
                  :expand-on-click-node="false"
                  :props="dataPermissionProps"
                  :filter-node-method="filterDataPermissionNode"
                  @check="
                    (data, node) => checkDataPermissionNode(data, node, 1)
                  "
                >
                  <span class="custom-tree-node" slot-scope="{ node }">
                    <span>{{ node.label }}</span>
                    <span
                      v-if="
                        node.level != 5 &&
                        node.childNodes &&
                        node.childNodes.length > 0
                      "
                    >
                      <el-button
                        type="text"
                        size="mini"
                        @click="allSelect(node)"
                        >（{{
                          !node.childNodes ||
                          node.childNodes.length == 0 ||
                          node.childNodes.filter((t) => !t.checked).length > 0
                            ? $l("全选")
                            : $l("反选")
                        }}）</el-button
                      >
                    </span>
                  </span>
                </el-tree>
              </panel>
            </el-col>
          </el-row>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="setDataPermissionDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="submitDataPermission"
            >{{ $l("确定") }}
          </el-button>
        </div>
      </el-dialog>
      <bindElevatorDialog ref="bindElevatorDialog"></bindElevatorDialog>
      <el-dialog
        ref="addSubUserDialog"
        title="新增副账号"
        :visible.sync="addSubUserDialogVisible"
        width="26%"
      >
        <el-form
          ref="addSubUserForm"
          :model="addSubUserForm"
          label-width="70px"
          size="medium"
          class="dialog-form add-sub-user-form"
          :rules="addSubUserRules"
        >
          <el-form-item :label="$l('手机号')" prop="telNum">
            <el-input v-model="addSubUserForm.telNum"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-row type="flex">
            <el-col>
              <el-button round @click="addSubUserDialogVisible = false"
                >{{ $l("取消") }}
              </el-button>
              <el-button round type="primary" @click="addSubUserSubmit"
                >{{ $l("确定") }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
import panel from "@/components/panel.vue";
import bindElevatorDialog from "@/components/bindElevatorDialog.vue";
import global from "@/mixins/global.js";

export default {
  name: "account",
  mixins: [global],
  components: {
    panel,
    bindElevatorDialog,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateUsername = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入用户名")));
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      if (this.isAdd && value.trim() == "") {
        callback(new Error(this.$l("请输入密码")));
      } else if (
        (this.isAdd || value.trim().length > 0) &&
        !this.$common.validatePassword(value)
      ) {
        callback(
          new Error(
            this.$l("必须包含字母、数字、特殊字符，至少8字符，不超过16个字符！")
          )
        );
      } else {
        callback();
      }
    };
    var validateRePassword = (rule, value, callback) => {
      if (value.trim() != this.editForm.password) {
        callback(new Error(this.$l("两次输入密码不一致!")));
      } else {
        callback();
      }
    };
    const reg = /^1[3-9]\d{9}$/;
    var validateTelNum = (rule, value, callback) => {
      if (value != null && value.trim().length > 0) {
        if (!reg.test(value)) {
          callback(new Error(this.$l("手机号格式错误！")));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var validateSubUserTelNum = (rule, value, callback) => {
      if (value == null || value.trim().length == 0) {
        callback(new Error(this.$l("请输入手机号！")));
      } else if (!reg.test(value)) {
        callback(new Error(this.$l("手机号格式错误！")));
      } else {
        callback();
      }
    };
    return {
      form: {
        pageNum: 0,
        pageSize: 0,
        username: "",
        telNum: "",
        roleId: "",
        disabled: null,
        userType: null,
        signingBranch: null,
        customer: null,
        useType: null,
        employeeId: null,
        companyName: null,
        creator: null,
        startExpireTime: null,
        endExpireTime: null,
      },
      roleList1: null, //用于搜索
      roleList2: null, //用于用户新增和编辑
      treeProps: {
        label: "name",
        isLeaf: "leaf",
      },
      dataTree: [],
      areaProps: {
        lazy: true,
        lazyLoad: this.loadArea,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      editDialogVisible: false,
      addSubUserForm: {
        telNum: null,
      },
      addSubUserDialogVisible: false,
      treeDialogVisible: false,
      isAdd: true,
      editDialogTitle: "",
      editForm: {
        userId: null,
        username: "",
        password: "",
        repassword: "",
        telNum: "",
        dataPermissions: [],
        oldDataPermissions: [],
        roleId: null,
        oldRoleId: null,
        oldAccountType: 0,
        roleType: 0,
        userType: "1",
        accountType: 0,
        userIds: null,
        areaId: null,
        areaName: null,
        areaCode: null,
        oldAreaCode: null,
        expireDate: null,
        expireDateObj: null,
        disabled: false,
        remark: null,
        // weixinSwitch: true,
        smsReceiverNum: 1,
        wxCount: 1,
        monitor: false,
        activate: false,
        signingBranch: null,
        customer: null,
        useType: null,
        employeeId: null,
      },
      expirePickerOptions: {
        disabledDate: (date) => {
          const curTime = new Date().getTime();
          return date.getTime() <= curTime;
        },
      },
      rules: {
        username: [
          { validator: validateUsername, trigger: "blur" },
          {
            min: 3,
            max: 16,
            message: this.$l("长度在 3 到 16 个字符"),
            trigger: "blur",
          },
        ],
        password: [{ validator: validatePassword, trigger: "blur" }],
        repassword: [{ validator: validateRePassword, trigger: "blur" }],
        telNum: [
          { validator: validateTelNum, trigger: "blur" },
          {
            min: 11,
            max: 11,
            message: this.$l("长度在 11 个字符"),
            trigger: "blur",
          },
        ],
        remark: [
          {
            max: 100,
            message: this.$l("长度不能超过 100 个字符"),
            trigger: "blur",
          },
        ],
        signingBranch: [
          {
            max: 100,
            message: this.$l("长度不能超过 100 个字符"),
            trigger: "blur",
          },
        ],
        customer: [
          {
            max: 50,
            message: this.$l("长度不能超过 50 个字符"),
            trigger: "blur",
          },
        ],
        useType: [
          {
            max: 50,
            message: this.$l("长度不能超过 50 个字符"),
            trigger: "blur",
          },
        ],
      },
      addSubUserRules: {
        telNum: [{ validator: validateSubUserTelNum, trigger: "blur" }],
      },
      tableData: null,
      selectedList: [],
      expandedKeys1: [],
      checkedKeys1: [],
      expandedKeys2: [],
      checkedKeys2: [],
      isStartChecked1: false,
      isStartChecked2: false,
      curUser: {
        userId: 0,
        parentId: 0,
        editUserId: 0,
        userIds: null,
        areaId: null,
        grtFlg: null,
        dataPermissions: [],
        oldDataPermissions: [],
      },
      isGrtFlg: false,
      loading: false,
      fullLoading: false,
      treeLoading: false,
      node1: null,
      resolve1: null,
      node2: null,
      resolve2: null,
      rootNodes1: [],
      rootNodes2: [],
      row: null,
      visibleArrow: false,
      importElevatorDialogVisible: false,
      importUserDialogVisible: false,
      fileList: [],
      file: null,
      setDataPermissionDialogVisible: false,
      dataPermissionList: [],
      dataPermissionProps: {
        label: "name",
        isLeaf: "leaf",
      },
      oldDataPermissionList: [],
      filterText: "",
      rootNode: null,
      resolve: null,
      curDataPermissionList: [],
      dataPermissionLoading: false,
      noCheckDataPermissionList: [],
      isAddPermission: true,
      expireTimeValues: [],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.dataPermissionTree.filter(val);
    },
  },
  mounted() {
    if (this.$store.state.user.userType > 1) {
      this.editForm.userType = this.$store.state.user.userType + "";
    }
    if (this.loaded) {
      this.loadRoles(0, this.$store.state.user.userId);
      this.initData();
    }
  },
  methods: {
    showBindElevator(userId, type) {
      this.$refs.bindElevatorDialog.show(userId, type);
    },
    filterDataPermissionNode(value, data) {
      if (!value) return true;
      const name = data.name;
      return name ? name.indexOf(value) !== -1 : false;
    },
    loadDataPermissionNode(node, resolve) {
      this.dataPermissionLoading = true;
      const pData = node.data;
      const level = node.level;
      if (!this.rootNode && !this.resolve && level == 0) {
        this.rootNode = node;
        this.resolve = resolve;
      }
      let parentId = pData.id;
      const userType = this.curUser.userType;
      this.$http
        .get(this.$apiConfig.get_account_data_permission_url, {
          params: {
            userId: this.curUser.parentId,
            parentId: parentId,
            level: level,
            userType: userType,
            grtFlg: this.curUser.grtFlg,
          },
        })
        .then((response) => {
          this.dataPermissionLoading = false;
          const result = response.data;
          let datas = [];
          if (result.code == 0) {
            let data = result.data;
            if (data) {
              if (level == 4) {
                data.forEach((item, i) => {
                  item.leaf = true;
                });
              }
              data.forEach((item, i) => {
                item.level = level + 1;
                if (level > 0) {
                  let id = pData.ids;
                  let name = pData.names;
                  if (userType == 1) {
                    item.ids = id + item.id + ",";
                  } else {
                    if (level == 3) {
                      item.ids = id + item.id.split(",").pop() + ",";
                    } else {
                      item.ids = id + item.name + ",";
                    }
                  }
                  item.parentId =
                    userType == 1 ? pData.id : pData.id.split(",").pop();
                  item.parentName = pData.name;
                  item.names = name + "-" + item.name;
                } else {
                  item.ids = item.id + ",";
                  item.names = item.name;
                }
              });
              datas = data;
            }
          }
          this.curDataPermissionList = datas;
          this.expandDataPermissionNode(level);
          resolve(datas);
        })
        .catch((error) => {
          this.dataPermissionLoading = false;
          this.$sentry.captureException(error);
          resolve([]);
        });
    },
    expandDataPermissionNode(level) {
      if (level > 0) {
        window.setTimeout(() => {
          let parentNode = null;
          let hasChildNode = false;
          this.curDataPermissionList.forEach((item, i) => {
            if (!parentNode) {
              parentNode = this.$refs.dataPermissionTree.getNode(
                item.ids
              ).parent;
            }
            if (
              this.oldDataPermissionList.filter((v) => v == item.ids).length > 0
            ) {
              this.$refs.dataPermissionTree.setChecked(item.ids, true, true);
              if (!hasChildNode) {
                hasChildNode = true;
              }
            } else if (
              this.oldDataPermissionList.filter((v) => v.indexOf(item.ids) == 0)
                .length > 0
            ) {
              let node = this.$refs.dataPermissionTree.getNode(item.ids);
              if (node && !node.checked) {
                node.indeterminate = true;
              }
              if (!hasChildNode) {
                hasChildNode = true;
              }
            }
          });
          if (hasChildNode) {
            parentNode.indeterminate = true;
            this.recursionNode(parentNode.data.ids, parentNode);
          } else if (parentNode && parentNode.checked) {
            parentNode.childNodes.forEach((item) => {
              this.$refs.dataPermissionTree.setChecked(
                item.data.ids,
                true,
                true
              );
            });
          }
        }, 100);
      } else {
        window.setTimeout(() => {
          this.$http
            .get(
              this.$apiConfig.get_account_permission_url +
                "/" +
                this.curUser.userId
            )
            .then((response) => {
              let result = response.data;
              if (result.code == 0) {
                this.oldDataPermissionList = result.data;
                this.expandDataPermissionNode(1);
              }
            })
            .catch((error) => {
              this.$sentry.captureException(error);
            });
        }, 100);
      }
    },
    checkDataPermissionNode(data, node, type) {
      if (type) {
        const n = this.$refs.dataPermissionTree.getNode(data.ids);
        this.recursionNode(data.ids, n);
        this.recursionChildNode(n);
      }
      const ids = data.ids;
      if (node.checkedKeys.filter((k) => k == ids).length == 0) {
        if (
          this.noCheckDataPermissionList.filter((v) => v.ids == ids).length == 0
        ) {
          this.noCheckDataPermissionList.push(data);
        }
      } else {
        let tempList = JSON.parse(
          JSON.stringify(this.noCheckDataPermissionList)
        );
        this.noCheckDataPermissionList = [];
        tempList.forEach((item, i) => {
          if (item.ids != ids) {
            this.noCheckDataPermissionList.push(item);
          }
        });
      }
    },
    submitDataPermission() {
      const nodes = this.$refs.dataPermissionTree.getCheckedNodes();
      let datas = [];
      if (nodes.length > 0) {
        let tempNodes = nodes.filter((n) => n.level == 1);
        tempNodes.forEach((node, i) => {
          datas.push(node.ids);
        });
        let maxLevel = 5;
        for (let i = 2; i <= maxLevel; i++) {
          tempNodes = nodes.filter((n) => n.level == i);
          tempNodes.forEach((node, ii) => {
            if (datas.filter((t) => node.ids.indexOf(t) == 0).length == 0) {
              datas.push(node.ids);
            }
          });
        }
        if (this.oldDataPermissionList.length > 0) {
          this.oldDataPermissionList.forEach((v, i) => {
            if (
              datas.filter(
                (v1) => v1 == v || v.indexOf(v1) == 0 || v1.indexOf(v) == 0
              ).length == 0
            ) {
              if (
                this.noCheckDataPermissionList.filter(
                  (v1) => v1.ids == v || v.indexOf(v1.ids) == 0
                ).length == 0
              ) {
                datas.push(v);
              }
            }
          });
        }
      } else {
        this.oldDataPermissionList.forEach((v, i) => {
          if (
            this.noCheckDataPermissionList.filter(
              (v1) => v1.ids == v || v.indexOf(v1.ids) == 0
            ).length == 0
          ) {
            datas.push(v);
          }
        });
      }
      this.confirmAlert(() => {
        let formData = new FormData();
        formData.append("userId", this.curUser.userId);
        formData.append("parentId", this.curUser.parentId);
        formData.append("userIds", this.curUser.userIds);
        formData.append("userType", this.curUser.userType);
        formData.append("grtFlg", this.curUser.grtFlg);
        formData.append("idsList", datas.join("|"));
        this.$http
          .post(this.$apiConfig.set_account_permission_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let data = response.data;
            this.message(data.code, data.msg);
            if (data.code == 0) {
              this.setDataPermissionDialogVisible = false;
              this.initData();
            }
          })
          .catch((error) => {
            this.errorMessage(0);
            this.$sentry.captureException(error);
          });
      }, "修改数据权限可能会影响子用户数据权限，是否确定修改？");
    },
    nodeExpand(dataObj, node, self) {
      if (node.data.children && node.data.children.length > 0) {
        return;
      }
      this.treeLoading = true;
      const level = node.data.ids.split(",").length - 1;
      this.$http
        .get(this.$apiConfig.get_account_permission_url, {
          params: {
            parentId: node.data.id,
            areaCode: null,
            level: level,
            type: 2,
          },
        })
        .then((response) => {
          this.treeLoading = false;
          let datas = response.data.data;
          for (let i = 0; i < datas.length; i++) {
            let data = datas[i];
            data.leaf = level == 4;
            data.ids = node.data.ids + data.id + ",";
            this.$refs.tree.append(data, node);
            if (level < 4) {
              if (dataObj == null) {
                if (
                  this.curUser.dataPermissions.filter(
                    (ids) => ids != data.ids && ids.startsWith(data.ids)
                  ).length > 0
                ) {
                  this.expandedKeys1.push(data.id);
                  this.$nextTick(() => {
                    this.nodeExpand(
                      null,
                      this.$refs.tree.getNode(data.id),
                      null
                    );
                  });
                }
              }
            }
            if (dataObj == null) {
              if (
                this.curUser.dataPermissions.filter((ids) => ids == data.ids)
                  .length == 1
              ) {
                this.checkedKeys1.push(data.id);
              }
            }
          }
          if (dataObj == null) {
            this.$nextTick(() => {
              this.$refs.tree.setCheckedKeys(this.checkedKeys1);
            });
          }
        })
        .catch((error) => {
          this.treeLoading = false;
          this.$sentry.captureException(error);
        });
    },
    showDataPermission(row) {
      this.setDataPermissionDialogVisible = true;
      this.curUser.grtFlg = row.grtFlg;
      this.isGrtFlg = row.grtFlg == "Y";
      if (!this.curUser || this.curUser.userId != row.userId) {
        this.curUser.userId = row.userId;
        this.curUser.parentId = row.parentId;
        this.curUser.userIds = row.userIds;
        this.curUser.userType = row.userType;
        this.dataPermissionList = [];
        this.oldDataPermissionList = [];
        this.curDataPermissionList = [];
        this.noCheckDataPermissionList = [];
        if (this.rootNode && this.resolve) {
          this.loadDataPermissionNode(this.rootNode, this.resolve);
        }
      }
    },
    checkNode(node) {
      if (!this.isStartChecked1) {
        this.isStartChecked1 = true;
      }
      if (!this.isStartChecked2) {
        this.isStartChecked2 = true;
      }
    },
    checkChange(data, checked, node) {
      //实现树单选
      if (checked == true) {
        this.editForm.areaName = data.name;
        this.areaId = data.id;
        this.$refs.areaTree.setCheckedNodes([data]);
      } else {
        if (this.areaId == data.id) {
          this.editForm.areaName = null;
        }
      }
    },
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    async loadArea(node, resolve) {
      let level = node.level;
      if (level == 0) {
        this.node2 = node;
        this.resolve2 = resolve;
      }
      let areaCode = this.$store.state.user.areaCode;
      let tempLevel = 0;
      if (areaCode) {
        tempLevel = areaCode.split(",").length - 1;
        if (tempLevel == 4) {
          return;
        }
        level = tempLevel + level;
      } else {
        areaCode = "";
      }
      let id = node.key;
      if (id != undefined) {
        let ids = id.split(",");
        id = ids[ids.length - 2];
      } else {
        id = this.$store.state.user.areaId;
      }
      if (this.$refs.areaTree != undefined && this.isStartChecked2) {
        this.checkedKeys2 = this.$refs.areaTree.getCheckedKeys();
      }
      var res = await this.$http.get(
        this.$apiConfig.get_account_permission_url,
        {
          params: {
            parentId: id,
            level: level,
            type: 1,
          },
        }
      );
      let result = res.data;
      if (result.code == 0) {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          if (level - tempLevel == 0) {
            item.id = areaCode + item.id + ",";
          } else {
            item.id = node.data.id + item.id + ",";
          }
          item.key = item.id;
        }
        if (level == 3) {
          for (let i = 0; i < data.length; i++) {
            data[i].leaf = true;
          }
        }
        if (level - tempLevel == 0) {
          this.rootNodes2 = data;
        }
        resolve(data);
        if (this.$refs.areaTree != undefined) {
          this.$refs.areaTree.setCheckedKeys(this.checkedKeys2);
        }
      }
    },
    showArea() {
      this.checkedKeys = [];
      this.expandedKeys = [];
      if (this.rootNodes2.length > 0) {
        this.rootNodes2.forEach((item, index) => {
          this.$refs.areaTree.remove(item);
        });
        this.rootNodes2 = [];
      }
      if (this.node2 && this.resolve2) {
        this.isStartChecked2 = false;
        this.loadArea(this.node2, this.resolve2);
      }
      if (this.row) {
        let areaCode = this.row.areaCode;
        let expandedIdArr = [];
        let checkedKeyArr = [];
        this.$refs.areaTree.setCheckedKeys(checkedKeyArr);
        checkedKeyArr.push(areaCode);
        let idArr = areaCode.split(",");
        let temp = "";
        for (let i = 0; i < idArr.length - 2; i++) {
          temp += idArr[i] + ",";
          expandedIdArr.push(temp);
        }
        if (this.$refs.areaTree != undefined) {
          this.$refs.areaTree.setCheckedKeys(checkedKeyArr);
        }
        this.checkedKeys2 = checkedKeyArr;
        this.expandedKeys2 = expandedIdArr;
      }
    },
    loadRoles(type, userId, fn) {
      this.$http
        .get(this.$apiConfig.get_account_roles_url, {
          params: {
            type: type,
            userId: userId,
          },
        })
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            let data = result.data;
            if (type == 1 || !this.isAdd) {
              this.roleList2 = data;
              if (data.length > 0) {
                this.editForm.roleId = data[0].roleId;
              } else {
                this.editForm.roleId = null;
              }
              if (fn) {
                fn();
              }
            } else {
              this.roleList1 = data;
            }
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    showAdd() {
      this.editDialogTitle = "新建账号";
      this.editDialogVisible = true;
      this.editForm.userId = null;
      this.row = null;
      this.checkedKeys2 = [];
      this.expandedKeys2 = [];
      this.editForm.areaName = null;
      this.isAdd = true;
      this.editForm.accountType = 0;
      this.editForm.oldAccountType = 0;
      this.loadRoles(1, this.$store.state.user.userId);
    },
    showEdit(row) {
      this.editDialogTitle = "编辑账号";
      this.editDialogVisible = true;
      this.row = row;
      this.isAdd = false;
      this.loadRoles(
        this.$store.state.user.roleType == 1 ? 0 : 1,
        row.parentId,
        () => {
          this.$http
            .get(this.$apiConfig.get_account_url + row.userId)
            .then((response) => {
              let result = response.data;
              if (result.code == 0) {
                let data = result.data;
                for (let key in this.editForm) {
                  if (data.hasOwnProperty(key)) {
                    this.editForm[key] = data[key];
                  }
                }
                this.editForm.userType += "";
                this.editForm.password = "";
                this.editForm.repassword = "";
                this.editForm.oldRoleId = data.roleId;
                this.editForm.oldAreaCode = data.areaCode;
                this.editForm.oldAccountType = data.accountType;
                if (this.editForm.expireDate) {
                  this.editForm.expireDateObj = Date.parse(
                    this.editForm.expireDate
                  );
                  if (isNaN(this.editForm.expireDateObj)) {
                    this.editForm.expireDateObj = new Date(
                      this.editForm.expireDate.replace("-", "/")
                    );
                  } else {
                    this.editForm.expireDateObj = new Date(
                      this.editForm.expireDate
                    );
                  }
                } else {
                  this.editForm.expireDateObj = null;
                }
                this.editForm.expireDate = null;
              }
            })
            .catch((error) => {
              this.$sentry.captureException(error);
            });
        }
      );
    },
    showDataPermissions2(row) {
      this.treeDialogVisible = true;
      let userId = row.userId;
      if (this.curUser.userId == userId) {
        return;
      }
      this.checkedKeys = [];
      this.expandedKeys = [];
      if (this.rootNodes1.length > 0) {
        this.$refs.tree.remove(this.rootNodes1[0]);
        this.rootNodes1 = [];
      }
      let areaCode = row.areaCode;
      this.editForm.areaCode = areaCode;
      if (this.node1 && this.resolve1) {
        this.isStartChecked1 = false;
        this.loadDataPermission(this.node1, this.resolve1);
      }
      this.curUser.userId = userId;
      this.curUser.userIds = row.userIds;
      this.curUser.username = row.username;
      this.$http
        .get(this.$apiConfig.get_account_permission_url + "/" + userId)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.curUser.oldDataPermissions = result.data;
            let expandedIdArr = [];
            let checkedKeyArr = [];
            this.$refs.tree.setCheckedKeys(checkedKeyArr);
            this.curUser.oldDataPermissions.forEach((item, index) => {
              checkedKeyArr.push(item);
              if (item != areaCode) {
                if (expandedIdArr.filter((id) => id == areaCode).length == 0) {
                  expandedIdArr.push(areaCode);
                }
                let idArr = item.replace(areaCode, "").split(",");
                let temp = areaCode;
                for (let i = 0; i < idArr.length - 2; i++) {
                  temp += idArr[i] + ",";
                  expandedIdArr.push(temp);
                }
              }
            });
            if (this.$refs.tree != undefined) {
              this.$refs.tree.setCheckedKeys(checkedKeyArr);
            }
            this.checkedKeys1 = checkedKeyArr;
            this.expandedKeys1 = expandedIdArr;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      if (this.expireTimeValues && this.expireTimeValues.length == 2) {
        this.form.startExpireTime = this.$common.formatDateTime(
          this.expireTimeValues[0]
        );
        this.form.endExpireTime = this.$common.formatDateTime(
          this.expireTimeValues[1]
        );
      } else {
        this.form.startExpireTime = null;
        this.form.endExpireTime = null;
      }
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_account_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    submit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          if (!this.editForm.roleId) {
            this.message(1, "请选择角色");
            return;
          }
          if (this.editForm.expireDateObj) {
            this.editForm.expireDate = this.$common.formatDateTime(
              this.editForm.expireDateObj
            );
          }
          if (this.editForm.username == this.editForm.password) {
            this.message(1, "用户名和密码不能一样");
            return;
          }
          let data = JSON.parse(JSON.stringify(this.editForm));
          if (data.password) {
            data.password = this.$md5(data.password);
          }
          data.repassword = "";
          this.$http
            .post(this.$apiConfig.save_account_url, data)
            .then((response) => {
              let data = response.data;
              this.message(data.code, data.msg);
              if (data.code == 0) {
                this.editDialogVisible = false;
                this.curUser.userId = 0;
                const userJson = localStorage.getItem("user");
                if (userJson) {
                  let user = JSON.parse(userJson);
                  if (user.username == this.$store.state.user.username) {
                    user.monitor = this.editForm.monitor;
                    user.telNum = this.editForm.telNum;
                    localStorage.setItem("user", JSON.stringify(user));
                    this.$store.state.user = user;
                  }
                }
                this.search();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    setUserPermission() {
      this.isStartChecked = false;
      let nodes = this.$refs.tree.getCheckedNodes();
      let idsArr = [];
      for (let i = 1; i <= 5; i++) {
        nodes
          .filter((n) => n.ids.split(",").length - 1 == i)
          .forEach((n) => {
            const ids = n.ids;
            const len = ids.split(",").length;
            if (idsArr.filter((id) => ids.startsWith(id)).length == 0) {
              idsArr.push(ids);
            }
          });
      }
      let formData = new FormData();
      formData.append("userId", this.curUser.userId);
      formData.append("userIds", this.curUser.userIds);
      formData.append("idsList", idsArr.join("|"));
      this.$http
        .post(this.$apiConfig.set_account_permission_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          let data = response.data;
          this.message(data.code, data.msg);
          if (data.code == 0) {
            this.treeDialogVisible = false;
          }
        })
        .catch((error) => {
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    deleteUser() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要删除的数据");
        return;
      }
      this.confirmAlert(() => {
        let userIdList = [];
        for (let i = 0; i < len; i++) {
          userIdList.push(this.selectedList[i].userId);
        }
        let formData = new FormData();
        formData.append("userIdList", userIdList);
        this.$http
          .post(this.$apiConfig.delete_account_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let data = response.data;
            this.message(data.code, data.msg);
            if (data.code == 0) {
              localStorage.removeItem(
                this.$store.state.user.username + "_alarm_date"
              );
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(3);
            this.$sentry.captureException(error);
          });
      });
    },
    onFileChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      }
      this.file = file.raw;
    },
    onFileRemove() {
      this.file = null;
    },
    openImportUser(type) {
      this.fileList = [];
      this.file = null;
      this.importUserDialogVisible = true;
    },
    importUser() {
      if (this.file == null) {
        this.message(1, "请选择要上传的文件");
        return;
      }
      if (!this.file.name.endsWith(".xlsx")) {
        this.message(1, "文件类型错误，请选择类型为xlsx的文件");
        return;
      }
      this.fullLoading = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.$http
        .post(this.$apiConfig.import_user_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.fullLoading = false;
          let result = response.data;
          this.message(result.code, result.msg);
          if (result.code == 0) {
            this.importUserDialogVisible = false;
            this.search();
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    openImportElevator(type) {
      this.fileList = [];
      this.file = null;
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要导入的用户");
        return;
      }
      if (len > 1) {
        this.message(1, "请选择一个用户");
        return;
      }
      if (this.$store.state.user.userId == this.selectedList[0].userId) {
        if (type == 0) {
          this.message(1, "不能给当前用户导入电梯数据");
        } else {
          this.message(1, "不能给当前用户删除电梯数据");
        }
        return;
      }
      this.importElevatorDialogVisible = true;
      this.isAddPermission = type == 0;
    },
    importElevator() {
      if (this.file == null) {
        this.message(1, "请选择要上传的文件");
        return;
      }
      if (!this.file.name.endsWith(".xlsx")) {
        this.message(1, "文件类型错误，请选择类型为xlsx的文件");
        return;
      }
      this.fullLoading = true;
      let formData = new FormData();
      formData.append("file", this.file);
      const user = this.selectedList[0];
      formData.append("parentId", user.parentId);
      formData.append("userId", user.userId);
      // formData.append("areaCode", user.areaCode);
      formData.append("userIds", user.userIds);
      formData.append("userType", user.userType);
      if (this.isAddPermission) {
        this.$http
          .post(this.$apiConfig.import_elevator_permission_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.fullLoading = false;
            let result = response.data;
            let data = result.data;
            if (result.code == 0) {
              this.importElevatorDialogVisible = false;
              this.curUser.userId = 0;
              let html = "";
              if (data.notJobNumList.length > 0) {
                html +=
                  '<span style="color:blue">不存在的电梯工号：</span><br/>' +
                  data.notJobNumList.join(",") +
                  "<br/>";
              }
              if (data.notAreaJobNumList.length > 0) {
                html +=
                  '<span style="color:blue">不在区域内的电梯工号：</span><br/>' +
                  data.notAreaJobNumList.join(",") +
                  "<br/>";
              }
              if (data.addFailureJobNumList.length > 0) {
                html +=
                  '<span style="color:blue">导入失败的电梯工号：</span><br/>' +
                  data.addFailureJobNumList.join(",");
              }
              if (html.length > 0) {
                html = `<div style="height:400px;word-wrap: break-word;overflow:auto;">${html}</div>`;
                this.$alert(html, "提示", {
                  dangerouslyUseHTMLString: true,
                });
              } else {
                this.message(result.code, result.msg);
              }
              this.initData();
            } else {
              this.message(result.code, result.msg);
            }
          })
          .catch((error) => {
            this.fullLoading = false;
            this.errorMessage(0);
            this.$sentry.captureException(error);
          });
      } else {
        // this.$http
        //   .post(this.$apiConfig.delete_elevator_permission_url, formData, {
        //     headers: {
        //       "Content-Type": "multipart/form-data",
        //     },
        //   })
        //   .then((response) => {
        //     this.fullLoading = false;
        //     let result = response.data;
        //     let data = result.data;
        //     if (result.code == 0) {
        //       this.message(result.code, result.msg);
        //       this.importElevatorDialogVisible = false;
        //       this.curUser.userId = 0;
        //     } else if (data) {
        //       let html =
        //         '<div style="height:400px;word-wrap: break-word;overflow:auto;">';
        //       if (data.notJobNumList.length > 0) {
        //         html +=
        //           '<span style="color:blue">不存在的电梯工号：</span><br/>' +
        //           data.notJobNumList.join(",") +
        //           "<br/>";
        //       }
        //       html += "</div>";
        //       this.$alert(html, "提示", {
        //         dangerouslyUseHTMLString: true,
        //       });
        //     } else {
        //       this.message(result.code, result.msg);
        //     }
        //   })
        //   .catch((error) => {
        //     this.fullLoading = false;
        //     this.errorMessage(0);
        //     this.$sentry.captureException(error);
        //   });
      }
    },
    clearElevatorPermission() {
      this.fileList = [];
      this.file = null;
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择一个用户");
        return;
      }
      if (len > 1) {
        this.message(1, "请选择一个用户");
        return;
      }
      if (this.$store.state.user.userId == this.selectedList[0].userId) {
        this.message(1, "不能清空当前用户的电梯权限");
        return;
      }
      this.confirmAlert(() => {
        let formData = new FormData();
        formData.append("userIds", this.selectedList[0].userIds);
        this.$http
          .post(this.$apiConfig.delete_elevator_permission_url, formData)
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.curUser.userId = 0;
              this.initData();
            }
          })
          .catch((error) => {
            this.errorMessage(0);
            this.$sentry.captureException(error);
          });
      }, "你确定要清空电梯权限吗?");
    },
    exportElevator() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要导入的用户");
        return;
      }
      if (len > 1) {
        this.message(1, "请选择一个用户");
        return;
      }

      if (this.selectedList[0].roleType == 1) {
        this.message(1, "超级管理员不能导出");
        return;
      }
      this.fullLoading = true;
      let filename =
        "工号数据_" + this.$common.formatCurrentDateTime(false) + ".xlsx";
      this.$http({
        url:
          this.$apiConfig.export_elevator_permission_url +
          "?userId=" +
          this.selectedList[0].userId,
        method: "get",
        responseType: "blob",
      })
        .then((response) => {
          this.fullLoading = false;
          const status = response.status;
          if (status != 200) {
            this.message(
              1,
              status == 201
                ? "导出失败"
                : status == 202
                ? "没有数据"
                : "数据量过大"
            );
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = filename;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    exportUser() {
      this.fullLoading = true;
      let filename =
        "账号信息表_" + this.$common.formatCurrentDateTime(false) + ".xlsx";
      const data = JSON.parse(JSON.stringify(this.form));
      if (data.disabled == "0") {
        data.disabled = false;
      } else if (data.disabled == "1") {
        data.disabled = true;
      }
      this.$http({
        url: this.$apiConfig.export_account_url,
        method: "post",
        responseType: "blob",
        data,
      })
        .then((response) => {
          this.fullLoading = false;
          const status = response.status;
          if (status != 200) {
            this.message(
              1,
              status == 201
                ? "导出失败"
                : status == 202
                ? "没有数据"
                : "数据量过大"
            );
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = filename;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    refreshUserElevatorCount() {
      this.confirmAlert(() => {
        // this.message(0, "后台已在处理，需要一段时间才可执行完");
        this.$http
          .get(this.$apiConfig.refresh_account_elevator_count_url)
          .then((response) => {
            const result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.initData();
            }
          })
          .catch((error) => {
            this.errorMessage(0);
            this.$sentry.captureException(error);
          });
      }, "你确定要刷新吗？");
    },
    sendSMS() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要发送短信的用户");
        return;
      }
      if (len > 10) {
        this.message(1, "用户数量不能超过10个");
        return;
      }
      const telNumList = this.selectedList
        .filter((t) => t.telNum != null && t.telNum.length > 0)
        .map((t) => t.telNum);
      if (telNumList.length != len) {
        this.message(1, "选择的用户中存在空的手机号");
        return;
      }
      this.confirmAlert(() => {
        this.fullLoading = true;
        this.$http
          .post(this.$apiConfig.send_user_sms_url, telNumList)
          .then((response) => {
            this.fullLoading = false;
            const result = response.data;
            const data = result.data;
            this.message(result.code, result.msg);
            if (result.code == 0 && data != null && data.length > 0) {
              this.message(
                result.code,
                this.$l("发送失败的手机号：") + data.join(",")
              );
            }
          })
          .catch((error) => {
            this.fullLoading = false;
            this.errorMessage(0);
            this.$sentry.captureException(error);
          });
      }, "你确定要发送短信吗？");
    },
    showAddSubUser() {
      this.addSubUserDialogVisible = true;
      this.addSubUserForm.telNum = null;
    },
    addSubUserSubmit() {
      this.$refs.addSubUserForm.validate((valid) => {
        if (valid) {
          this.$http
            .post(
              `${this.$apiConfig.add_sub_user_url}?telNum=${this.addSubUserForm.telNum}`
            )
            .then((response) => {
              let data = response.data;
              this.message(data.code, data.msg);
              if (data.code == 0) {
                this.addSubUserDialogVisible = false;
                this.search();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    userTypeFormatter(row) {
      if (row.userType == 1) {
        return this.$l("日立");
      } else if (row.userType == 3) {
        return this.$l("家用梯");
      } else if (row.userType == 4) {
        return this.$l("电梯服务商");
      }
      return this.$l("物业");
    },
    disabledFormatter(row) {
      if (row.disabled == 1) {
        return this.$l("是");
      }
      return this.$l("否");
    },
    syncStatusFormatter(row) {
      if (row.syncStatus) {
        return this.$l("已同步");
      }
      return this.$l("未同步");
    },
    downloadTemplate(fileName) {
      this.$http({
        url: this.$apiConfig.download_template_url + "?fileName=" + fileName,
        method: "get",
        responseType: "blob",
      })
        .then((response) => {
          const status = response.status;
          if (status != 200) {
            this.message(1, "下载失败");
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = fileName;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    onCheckChange(checked) {
      this.curUser.grtFlg = checked ? "Y" : null;
      this.dataPermissionList = [];
      this.oldDataPermissionList = [];
      this.curDataPermissionList = [];
      this.noCheckDataPermissionList = [];
      if (this.rootNode && this.resolve) {
        this.loadDataPermissionNode(this.rootNode, this.resolve);
      }
    },
    allSelect(node) {
      try {
        let checked = node.childNodes.filter((t) => !t.checked).length > 0;
        let datas = [];
        node.childNodes.forEach((item) => {
          this.$refs.dataPermissionTree.setChecked(item.data.ids, checked);
          datas.push(item.data);
          this.checkDataPermissionNode(
            item.data,
            {
              checkedKeys: this.$refs.dataPermissionTree
                .getCheckedNodes()
                .map((t) => t.ids),
            },
            0
          );
        });
        if (datas.length > 0) {
          if (checked) {
            node.indeterminate = true;
          } else {
            this.$refs.dataPermissionTree.setChecked(node.data.ids, false);
          }
          this.recursionNode(node.data.ids, node);
        }
      } catch (error) {
        console.log(error);
      }
    },
    recursionNode(ids, node) {
      let parentNode = node.parent;
      if (parentNode != null && !(parentNode.data instanceof Array)) {
        const childNodes = parentNode.childNodes;
        const checkedLen = childNodes.filter((t) => t.checked).length;
        // const childCheckedLen = node.childNodes.filter((t) => t.checked).length;
        // const childIndeterminateLen = node.childNodes.filter(
        //   (t) => t.indeterminate
        // ).length;
        const len = childNodes.length;
        // if (
        //   (childCheckedLen > 0 || childIndeterminateLen > 0) &&
        //   !node.checked &&
        //   !node.indeterminate
        // ) {
        //   this.$refs.dataPermissionTree.setChecked(node.data.ids, false);
        //   node.indeterminate = true;
        // }
        const indeterminateLen = childNodes.filter(
          (t) => t.indeterminate
        ).length;
        if (checkedLen == len) {
          // this.$refs.dataPermissionTree.setChecked(parentNode.data.ids, false);
          parentNode.indeterminate = true;
        } else if (checkedLen == 0) {
          if (parentNode.indeterminate && indeterminateLen == 0) {
            this.$refs.dataPermissionTree.setChecked(
              parentNode.data.ids,
              false
            );
          }
          if (!parentNode.indeterminate && indeterminateLen > 0) {
            this.$refs.dataPermissionTree.setChecked(
              parentNode.data.ids,
              false
            );
            parentNode.indeterminate = true;
          }
        } else if (!parentNode.indeterminate) {
          this.$refs.dataPermissionTree.setChecked(parentNode.data.ids, false);
          parentNode.indeterminate = true;
        }
        this.recursionNode(ids, parentNode);
      }
    },
    recursionChildNode(node) {
      const childNodes = node.childNodes;
      if (childNodes && childNodes.length > 0) {
        childNodes.forEach((item) => {
          this.$refs.dataPermissionTree.setChecked(item.data.ids, node.checked);
          this.recursionChildNode(item);
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.toolbar-btn {
  width: 40%;
  white-space: normal;
  .el-button {
    margin-bottom: 14px;
  }
}
.dialog-form {
  .el-input {
    width: 400px;
  }
  .el-textarea {
    width: 400px;
  }
  .el-select {
    width: 400px;
  }
  .el-cascader {
    width: 400px;
  }
}
.add-sub-user-form {
  .el-input {
    width: 100%;
  }
}
.select-tree {
  width: 370px;
  height: 200px;
  overflow-y: scroll;
}
/* 菜单滚动条 */
.select-tree::-webkit-scrollbar {
  z-index: 11;
  width: 6px;
}
.select-tree::-webkit-scrollbar-track,
.select-tree::-webkit-scrollbar-corner {
  background: #fff;
}
.select-tree::-webkit-scrollbar-thumb {
  border-radius: 5px;
  width: 6px;
  background: #b4bccc;
}
.select-tree::-webkit-scrollbar-track-piece {
  background: #fff;
  width: 6px;
}
.container {
  .filter {
    padding: 14px 25px;
    .el-input {
      width: 80%;
      margin-right: 30px;
    }
    /deep/ .el-checkbox__label {
      padding-left: 6px;
    }
  }
}
</style>
